<template>
    <div>
        <button type="button" @click="appendDataToModal" class="btn btn-sm btn-dark"
                data-toggle="modal" data-target="#description_modal">
            {{ $t('label.description') }}
        </button>

        <div id="description_modal" class="modal fade rtl" role="dialog">
            <div class="modal-dialog">

                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <div id="title">
                        </div>
                        <button type="button" class="close float-right mr-0" data-dismiss="modal">&times;</button>
                    </div>
                    <div id="data_sheet" class="modal-body mb-4">
                        <table class="table table-hover">
                            <thead id="table-header">
                            <tr>
                                <th class="table-info" colspan="2">{{ $t('transactions-report.transactionDetails') }}</th>
                            </tr>
                            </thead>
                            <tbody id="transaction_detail">
                            </tbody>
                        </table>
                        <table id="error" class="table table-hover">
                            <thead id="table-header-error">
                            <tr>
                                <th class="table-info" colspan="2">{{ $t('transactions-report.transactionError') }}</th>
                            </tr>
                            </thead>
                            <tbody id="error_detail">
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    import $ from 'jquery'
    import { i18n } from '@/plugins/i18n'

    export default Vue.extend({
        props: {
            row: {
                required: true,
            },
            index: {
                required: true,
            },
            datatable: {
                required: true,
            }
        },
        methods: {
            appendDataToModal() {
                function simpleText(data, title){
                    return '<tr><td style="width: 155px;">' + title + '</td>' +
                        '<td>' + data + '</td></tr>'
                }
                function simpleTextLtr(data, title){
                    return '<tr>' +
                        '<td style="width: 155px;">' + title + '</td>' +
                        '<td style="direction: ltr;">' + data + '</td>' +
                        '</tr>'
                }

                let transaction_detail = $('#transaction_detail').empty()
                let error_detail = $('#error_detail').empty()
                let title = $('#title').empty()

                let ps_elements =
                    '<h4 class="modal-title float-left p-0 m-0">' +
                    i18n.t('transactions-report.transactionDetails') + '</h4>'

                title.append (ps_elements)

                ps_elements = ''
                let ps_elements2 =
                    '<h4 class="modal-title float-left p-0 m-0">' +
                    i18n.t('transactions-report.transactionDetails') + '</h4>'

                title.append (ps_elements2)

                ps_elements2 = ''
0

                if (this.row.settle_date)
                    ps_elements += simpleText(this.row.settle_date, 'تاریخ تسویه')

                if (this.row.status==="موفق")
                    ps_elements += simpleText(this.row.status_description, 'وضعیت تراکنش')

                if (this.row.pan_masked)
                    ps_elements += simpleText(this.row.pan_masked, 'شماره کارت')
                if (this.row.storename)
                    ps_elements += simpleText(this.row.storename, 'نام فروشگاه')
                if (this.row.merchant_id)
                    ps_elements += simpleText(this.row.merchant_id, 'شماره پذیرنده')
                if (this.row.terminal_id)
                    ps_elements += simpleText(this.row.terminal_id, 'شماره پایانه')
                if (this.row.wage_bank)
                    ps_elements += simpleText(this.row.wage_bank, i18n.t('label.banking_wage'))
                transaction_detail.append (ps_elements)
                if (this.row.status==="ناموفق") {
                    ps_elements2 += simpleText(this.row.status_description,'وضعیت خطا')
                }

                error_detail.append(ps_elements2)

            }
        }
    })
</script>

<style>

</style>